import React from "react";
import { ScrollToTopButton } from "../components/ScrollToTopButton/ScrollToTopButton";
import { FooterTwo } from "../components/Footers/FooterTwo";
import { HeaderThree } from "../components/Headers/HeaderThree";
import { Breadcrumb } from "../components/Breadcrumb/Breadcrumb";
import { HeaderSix } from "../components/Headers/HeaderSix";

export const Layout = ({ children, header, footer, breadcrumb, title }) => {
  return (
    <>
      {/* Scroll-top  */}
      <ScrollToTopButton />

      {/* header */}
      {header === 3 && <HeaderThree />}
      {(!header || header === 6) && <HeaderSix />}

      {/* breadcrumb */}
      {breadcrumb && <Breadcrumb text={breadcrumb} title={title} />}

      {/* children */}
      <main className="fix">{children}</main>

      {/* footer */}
      {(!footer || footer === 2) && <FooterTwo />}
    </>
  );
};
